import { ClassFlag } from "../../../../../../library-js/dom-tools/ClassFlag";
import { Func } from "../../../../../../library-js/tools/TypeUtilities";
import { InspectorField } from "../../../../../../library-templates/inspector/fields/InspectorField";
import { EnumValue } from "../../../../../../library-templates/inspector/types/EnumValue";

export enum SlicingModeType
{
  NoSlicing,
  Duration,
  Beats,
  Division
}

export class DurationSlicingOptions
{
  duration:number = 1;
}

export class BeatsSlicingOptions
{
  bpm:number = 120;
  beats:number = 16;
}

export class DivisionSlicingOptions
{
  divisions:number = 10;
} 



export class SlicingMode
{
  type = new EnumValue<SlicingModeType>( SlicingModeType, SlicingModeType.Beats);

  beatsSlicingOptions    = new BeatsSlicingOptions();
  durationSlicingOptions = new DurationSlicingOptions();  
  divisionSlicingOptions = new DivisionSlicingOptions();  

  static definesInspectorFieldsVisibilites( field:InspectorField<any> )
  {
    EnumValue.defineEnumVisibilities( 
      field, "type", 
      { 
        beatsSlicingOptions: SlicingModeType.Beats, 
        durationSlicingOptions: SlicingModeType.Duration, 
        divisionSlicingOptions: SlicingModeType.Division
      }
    );    
  }
}